import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { message, notification } from 'antd';
import {history} from '@umijs/max';
import {getCookie, removeCookie, Key} from "@/utils/cookie";

const loginPath = '/user/login';

// 错误处理方案： 错误类型
// enum ErrorShowType {
//   SILENT = 0,
//   WARN_MESSAGE = 1,
//   ERROR_MESSAGE = 2,
//   NOTIFICATION = 3,
//   REDIRECT = 9,
// }
// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data: any;
  total?: number;
  detail?: string;
}

const codeMap = {
  401: '认证失败，请登录!',
  422: '参数解析错误，请检查!',
  500: '服务器错误，请联系重试或者联系管理员!',
  501: '业务错误!',
  999: '未知错误，请联系管理员!',
};

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  // 错误处理： umi@3 的错误处理方案。
  errorConfig: {
    // 错误抛出
    errorThrower: (res) => {
      const { data, detail } =
        res as unknown as ResponseStructure;
      if (!data) {
        const error: any = new Error(detail);
        error.name = 'BizError';
        error.info = { detail, data };
        throw error; // 抛出自制的错误
      }
    },
    // 错误接收及处理
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;
      // 我们的 errorThrower 抛出的错误。
      if (error.response) {
        // 401：登录失效（含一小时未操作滑动会话过期），清除凭据并跳转登录页
        if (error.response.status === 401) {
          removeCookie(Key.ATK);
          message.error(error.response.data?.detail || codeMap[401]);
          if (history.location.pathname !== loginPath) {
            history.push(loginPath);
          }
          return;
        }
        if (error.response.data?.detail) {
          message.error(error.response.data.detail)
        } else {
          // @ts-ignore
          const msg = codeMap?.[error.response.status] || codeMap[999];
          message.error(msg);
        }
      } else if (error.request) {
        // 请求已经成功发起，但没有收到响应
        // \`error.request\` 在浏览器中是 XMLHttpRequest 的实例，
        // 而在node.js中是 http.ClientRequest 的实例
        message.error('None response! Please retry.');
      } else {
        // 发送请求时出了点问题
        message.error('Request error, please retry.');
      }
    },
  },

  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      // 拦截请求配置，进行个性化处理。
      const token = getCookie(Key.ATK);
      if (!token) {

        // const { location } = history;
        // if (location.pathname !== loginPath) {
        //   history.push(`${loginPath}?redirect=${encodeURIComponent(location.pathname + location.search)}`);
        // }

        // 跳转登录页面
        history.push(loginPath);
      }
      const authHeader = {Authorization: `Bearer ${token}`};

      // 大文件上传（FormData / requestType: 'form'）放宽超时到 30 分钟，
      // 避免全局 60s 超时把大视频/PDF 上传过早切断
      const isUpload =
        (typeof FormData !== 'undefined' && config.data instanceof FormData) ||
        (config as any).requestType === 'form';
      const uploadOverride = isUpload && config.timeout === undefined
        ? { timeout: 30 * 60 * 1000 }
        : {};

      return {
        ...config,
        ...uploadOverride,
        headers: { ...config.headers, ...authHeader },
      };
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response) => {
      // 拦截响应数据，进行个性化处理
      const { data } = response as unknown as ResponseStructure;

      if (data?.success === false) {
        message.error('请求失败！');
      }
      return response;
    },
  ],
};
